import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  BookOpen,
  FileText,
  HelpCircle,
  PenLine,
  BarChart2,
  Megaphone,
  Sun,
  Moon,
  Newspaper,
  CalendarDays,
  Flame,
  Lock,
  Sparkles,
  Target,
  Trophy,
  Zap,
} from "lucide-react";
import { API_BASE } from "../../config";
import axios from "axios";
import { toast } from "react-hot-toast";
import DisplayNameModal from "./DisplayNameModal";

const DashboardHome = () => {
  const [user, setUser] = useState(() => {
        try {
      return JSON.parse(localStorage.getItem("user")) || {};
    } catch {
      return {};
    }
  });
  const [currentUser,
  setCurrentUser] =
  useState(() => {

    try {

      return JSON.parse(
        localStorage.getItem(
          "user"
        )
      ) || {};

    } catch {

      return {};
    }
  });
  const [announcements, setAnnouncements] = useState([]);
  const [dailyQuote, setDailyQuote] = useState("");
  const [darkMode, setDarkMode] = useState(localStorage.getItem("theme") === "dark");
  const [bannerHidden, setBannerHidden] = useState(
    localStorage.getItem("dashboardRenewBannerHidden") === "true"
  );
  const [renewLoading, setRenewLoading] = useState(false);
  const [

activities,

setActivities

] = useState(() => {

try {

return JSON.parse(

sessionStorage.getItem(
"dashboardActivities"
)

) || [];

}

catch {

return [];

}

});

const [

activitiesLoaded,

setActivitiesLoaded

] = useState(

JSON.parse(

sessionStorage.getItem(
"dashboardActivities"
)

)?.length > 0

);
  const [showDisplayNameModal,
  setShowDisplayNameModal] =
  useState(false);
  const [showCompetitiveCard,
  setShowCompetitiveCard] =
  useState(false);
  const [
  dismissedCompetitiveModal,

  setDismissedCompetitiveModal
] = useState(false);
  const [examCycles, setExamCycles] =
  useState([]);
  const [refreshBadges, setRefreshBadges] =
  useState(false);

  const [analytics, setAnalytics] =
  useState(null);

  // =========================
// Live XP Popup
// =========================

const [xpPopup,
  setXpPopup] =
  useState(null);
  // =========================
// Rank Change
// =========================

const [rankChange,
  setRankChange] =
  useState(null);

const [analyticsLoading,
  setAnalyticsLoading] =
  useState(true);

  // =========================
// Leaderboard
// =========================

const [leaderboard,
  setLeaderboard] =
  useState([]);

const [leaderboardLoading,
  setLeaderboardLoading] =
  useState(true);

const [currentRank,
  setCurrentRank] =
  useState(null);
  const [previousRank,
  setPreviousRank] =
  useState(null);

const [percentile,
  setPercentile] =
  useState(0);

  const [totalUsers,
  setTotalUsers] =
  useState(0);

  // =========================
// Live Current Date
// =========================

const [liveDate, setLiveDate] =
  useState(new Date());

const readStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user")) || {};
  } catch {
    return {};
  }
};

const hasCompetitiveDisplayName = (candidate) =>
  typeof candidate?.displayName === "string" &&
  candidate.displayName.trim().length > 0;


  const quotePool = [
    "Push yourself, because no one else is going to do it for you.",
    "Dream big. Start small. Act now.",
    "The secret of getting ahead is getting started.",
    "Discipline is the bridge between goals and accomplishment.",
    "The harder you work for something, the greater you'll feel when you achieve it.",
    "Don't watch the clock; do what it does. Keep going.",
    "Success is the sum of small efforts repeated day in and out.",
    "Believe you can and you're halfway there.",
    "If it doesn't challenge you, it won't change you.",
    "Every accomplishment starts with the decision to try.",
  ];

  // ✅ Subscription info
  const expiryDate = user?.subscriptionExpiresAt
  ? new Date(user.subscriptionExpiresAt)
  : null;

const now = new Date();

const hasSubscription = !!expiryDate;
const isActive =
  user?.hasPaid && hasSubscription && expiryDate > now;

const isExpired =
  hasSubscription && expiryDate < now;

const isFreeUser =
  !hasSubscription && !user?.hasPaid;

const daysLeft =
  isActive
    ? Math.ceil((expiryDate - now) / (1000 * 60 * 60 * 24))
    : 0;

// =========================
// Fetch Analytics
// =========================

const fetchAnalytics =
  async () => {

    try {

      if (!user?.token){

setAnalyticsLoading(
false
);

setAnalytics(
null
);

return;

}

      const res =
        await axios.get(

          `${API_BASE}/api/user/analytics/me`,

          {
            headers: {
              Authorization:
                `Bearer ${user.token}`,
            },
          }
        );

      setAnalytics(
        res.data.analytics
      );

    } catch (err) {

      console.error(
        "Failed to fetch analytics",
        err
      );

    } finally {

      setAnalyticsLoading(
        false
      );
    }
  };

  // =========================
// Fetch Leaderboard
// =========================

const fetchLeaderboard =
  async () => {

    try {

      if (
        !user?.token ||
        !currentUser?.hasPaid ||
        !hasCompetitiveDisplayName(currentUser)
      ) {

        setLeaderboardLoading(
          false
        );

        return;
      }

      const res =
        await axios.get(

  `${API_BASE}/api/user/leaderboard`,

  {

    headers: {

      Authorization:

        `Bearer ${
          currentUser?.token
        }`,
    },
  }
);



      setLeaderboard(
        res.data.leaderboard || []
      );

      const newRank =
  res.data.currentUserRank;



setPreviousRank(
  currentRank
);

setCurrentRank(
  newRank
);



// =========================
// Rank Improvement
// =========================

if (

  currentRank &&

  newRank &&

  newRank < currentRank
) {

  setRankChange({

    oldRank:
      currentRank,

    newRank,
  });



  setTimeout(() => {

    setRankChange(null);

  }, 4000);
}

      setPercentile(
        res.data.percentile || 0
      );

      setTotalUsers(
  res.data.totalUsers || 0
);

      // =========================
// AIR Improvement
// =========================

const currentUserData =
  res.data.leaderboard?.find(
    (u) =>
      u.rank === newRank
  );



if (
  currentUserData
) {

  const newAIR =
    currentUserData.projectedAIR;



  const oldAIR =
    leaderboard.find(
      (u) =>
        u.rank === currentRank
    )?.projectedAIR;



  if (
    oldAIR &&
    newAIR &&
    newAIR < oldAIR
  ) {

    window.dispatchEvent(

      new CustomEvent(

        "xpGained",

        {

          detail: {

            xp: 0,

            message:
              `AIR Improved ${oldAIR} → ${newAIR}`,

            air: newAIR,
          },
        }
      )
    );
  }
}

    } catch (err) {

      console.error(
        "Leaderboard fetch failed",
        err
      );

    } finally {

      setLeaderboardLoading(
        false
      );
    }
  };

// =========================
// Live XP Events
// =========================

useEffect(() => {

  const handleXpGain = (event) => {

    const data = event.detail;

    setXpPopup(data);

    setTimeout(() => {

      setXpPopup(null);

    }, 3000);

    fetchLeaderboard();

    fetchAnalytics();
  };  

  window.addEventListener(
    "xpGained",
    handleXpGain
  );

  return () => {

    window.removeEventListener(
      "xpGained",
      handleXpGain
    );
  };

}, []);

// =========================
// Initial Leaderboard Fetch
// =========================

useEffect(() => {

  fetchLeaderboard();

}, [
  currentUser?.token,
  currentUser?.displayName,
  currentUser?.hasPaid
]);

  // ✅ Fetch announcements + quote
  useEffect(() => {
    const fetchAnnouncements = async () => {
      if (!user?.token) return;

      try {
        const res = await fetch(`${API_BASE}/api/announcements/active`, {
          headers: { Authorization: `Bearer ${user.token}` },
        });

        if (!res.ok) {
          console.warn("⚠️ Announcement fetch failed:", res.status, res.statusText);
          setAnnouncements([]);
          return;
        }

        const data = await res.json();

        // ✅ Normalize & ensure same-day announcements show properly
        const normalized = Array.isArray(data)
  ? data
      .map((a) => {
        // Convert visibility dates safely (avoid timezone shifts)
        const start = new Date(a.visibility.startDate);
        const end = new Date(a.visibility.endDate);

        // Extract only the date part (YYYY-MM-DD) to display as entered
        const formatDate = (d) => {

const date =
new Date(d);

return (
date.getFullYear()
+
"-"
+
String(
date.getMonth()+1
).padStart(2,"0")
+
"-"
+
String(
date.getDate()
).padStart(2,"0")
);

};

const startDate =
formatDate(
a.visibility.startDate
);

const endDate =
formatDate(
a.visibility.endDate
);

        return {
          ...a,
          visibility: {
            startDate,
            endDate,
          },
        };
      })
      .sort(
        (a, b) =>
          new Date(b.visibility.startDate) - new Date(a.visibility.startDate)
      )
  : [];

setAnnouncements(normalized);
        console.log(`✅ Announcements loaded: ${normalized.length}`);
      } catch (err) {
        console.error("❌ Announcements fetch failed:", err);
        setAnnouncements([]);
      }
    };

    const rotateQuote = () => {
      const today = new Date();
      const shuffled = [...quotePool].sort(() => Math.random() - 0.5);
      setDailyQuote(shuffled[today.getDate() % shuffled.length]);
    };

    const fetchLiveActivities = async () => {

  try {

const activityList = [];

// =========================
// Shared latest content refs
// =========================

let latestEditorial = null;

let latestNote = null;

let latestMagazine = null;

let latestMCQ = null;

let tests = [];

    // =========================
// Competitive Identity Check
// =========================

const identityUser = {
  ...currentUser,
  ...readStoredUser(),
};

if (
  identityUser?.hasPaid &&
  hasCompetitiveDisplayName(identityUser)
) {
  setShowCompetitiveCard(false);
  setShowDisplayNameModal(false);
} else if (
  identityUser?.hasPaid &&
  !dismissedCompetitiveModal
) {
  setShowCompetitiveCard(true);
  setShowDisplayNameModal(false);
}

    // =========================
    // Editorials
    // =========================
    try {

      const editorialRes =
        await axios.get(

  `${API_BASE}/api/user/editorials`,

  {
    headers: {
      Authorization:
        `Bearer ${user.token}`,
    },
  }
);

      latestEditorial =
editorialRes.data?.[0];

      if (latestEditorial) {
        activityList.push(
          `🔥 New Editorial: ${latestEditorial.title}`
        );
      }

    } catch (err) {}



    // =========================
    // Notes
    // =========================
    try {

      const notesRes =
        await axios.get(
          `${API_BASE}/api/user/notes`
        );

      latestNote =
notesRes.data?.[0];

      if (latestNote) {
        activityList.push(
          `📘 New Notes Uploaded`
        );
      }

    } catch (err) {}



    // =========================
    // Monthly Magazines
    // =========================
    try {

      const magazineRes =
        await axios.get(
          `${API_BASE}/api/monthly-magazines/all`
        );

      latestMagazine =
magazineRes.data?.magazines?.[0];

      if (latestMagazine) {
        activityList.push(
          `📰 ${latestMagazine.month} ${latestMagazine.year} Magazine Added`
        );
      }

    } catch (err) {}



    // =========================
    // MCQs
    // =========================
    try {

     const yesterday =
new Date();

yesterday.setDate(
yesterday.getDate()
-1
);

const safeDate =

yesterday
.toISOString()
.split("T")[0];

const mcqRes =
await axios.get(

`${API_BASE}/api/user/mcqs`,

{

headers:{

Authorization:
`Bearer ${user.token}`,

},

params:{

date:
safeDate,

},

}

);

      latestMCQ =
mcqRes.data?.mcqs?.[0];

      if (latestMCQ) {
        activityList.push(
          `🧠 New MCQ Practice Uploaded`
        );
      }

    } catch (err) {}



    // =========================
    // Test Series
    // =========================
    try {

const testRes =
await axios.get(

`${API_BASE}/api/user/tests/prelims`,

{

headers:{

Authorization:
`Bearer ${user.token}`,

},

}

);

tests =

Array.isArray(
testRes.data?.tests
)

?

testRes.data.tests

:

Array.isArray(
testRes.data
)

?

testRes.data

:

[];

if (
tests.length
) {

activityList.push(
"📊 New Test Series Available"
);

}

}

catch(err){

console.error(
"Failed to fetch tests",
err
);

}
    const uniqueActivities = [

...new Set(
activityList
),

];

// =========================
// NEW badge sync
// =========================

try {

if (
latestEditorial
){

localStorage.setItem(

"editorial-analysis-latest",

latestEditorial.createdAt ||

new Date().toISOString()

);

}

if (
latestNote
){

localStorage.setItem(

"notes-latest",

latestNote.createdAt ||

new Date().toISOString()

);

}

if (
latestMCQ
){

localStorage.setItem(

"mcqs-latest",

latestMCQ.createdAt ||

new Date().toISOString()

);

}

if (
tests.length
){

localStorage.setItem(

"test-series-latest",

new Date().toISOString()

);

}

if (
latestMagazine
){

localStorage.setItem(

"monthly-magazines-latest",

latestMagazine.createdAt ||

new Date().toISOString()

);

}

setRefreshBadges(
(prev)=>!prev
);

}

catch(e){

console.error(
"Badge sync failed",
e
);

}

// =========================
// Live ticker
// =========================

sessionStorage.setItem(

"dashboardActivities",

JSON.stringify(
uniqueActivities
)

);

setActivities(
uniqueActivities
);

setActivitiesLoaded(
true
);

  } catch (err) {
    console.error(err);
  }
};

const fetchExamCycles = async () => {

  try {

    const res = await axios.get(
      `${API_BASE}/api/exam-cycles/active`
    );

    setExamCycles(
      res.data.cycles || []
    );

  } catch (err) {

    console.error(
      "Failed to fetch exam cycles",
      err
    );
  }
};

// =========================
// Initial Fetch
// =========================

fetchAnnouncements();

rotateQuote();

if (

activities.length

===

0

){

fetchLiveActivities();

}

else {

setTimeout(

()=>{

fetchLiveActivities();

},

2000

);

}

fetchExamCycles();

fetchAnalytics();

fetchLeaderboard();

// =========================
// Auto Refresh
// =========================

const refreshInterval =
setInterval(() => {

  fetchLiveActivities();

  fetchAnalytics();

  fetchLeaderboard();

}, 300000);

// =========================
// Cleanup
// =========================

return () => {

  clearInterval(
    refreshInterval
  );

};

}, [

user?.token,

activities.length,

currentUser?.hasPaid,

currentUser?.displayName,

dismissedCompetitiveModal

]);

  // ✅ Dark mode toggle
  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      document.documentElement.classList.remove("dark");
      localStorage.setItem("theme", "light");
    }
  }, [darkMode]);

  // =========================
// Auto Refresh Date
// =========================

useEffect(() => {

  const interval =
    setInterval(() => {

      setLiveDate(
        new Date()
      );

    }, 60 * 1000); // every minute

  return () =>
    clearInterval(interval);

}, []);

  // ✅ Listen for external user updates
// ✅ Listen for external user updates
useEffect(() => {

  const syncUser = () => {

    const updatedUser =
      readStoredUser();



    if (updatedUser) {

      setCurrentUser(
        updatedUser
      );

      setUser(
        updatedUser
      );

      if (
        updatedUser?.hasPaid &&
        hasCompetitiveDisplayName(updatedUser)
      ) {

        setShowCompetitiveCard(
          false
        );

        setShowDisplayNameModal(
          false
        );
      }
    }
  };



  window.addEventListener(
    "userUpdated",
    syncUser
  );

  window.addEventListener(
    "storage",
    syncUser
  );

  syncUser();



  return () => {

    window.removeEventListener(
      "userUpdated",
      syncUser
    );

    window.removeEventListener(
      "storage",
      syncUser
    );
  };

}, [refreshBadges]);

useEffect(() => {
  if (
    currentUser?.hasPaid &&
    hasCompetitiveDisplayName(currentUser)
  ) {
    setShowCompetitiveCard(false);
    setShowDisplayNameModal(false);
  }
}, [
  currentUser?.hasPaid,
  currentUser?.displayName,
]);

  // ✅ Banner controls
  const handleHideBanner = () => {
    setBannerHidden(true);
    localStorage.setItem("dashboardRenewBannerHidden", "true");
  };

  const handleShowBanner = () => {
    setBannerHidden(false);
    localStorage.removeItem("dashboardRenewBannerHidden");
  };

  // =========================
// Premium Upgrade
// =========================

const handleCompetitiveUpgrade = async () => {

  try {

    // Razorpay SDK check
    if (!window.Razorpay) {

      toast.error(
        "Payment UI failed to load"
      );

      return;
    }

    // User auth check
    if (!user?.token) {

      toast.error(
        "Please login again"
      );

      return;
    }



    // =========================
    // Create Order
    // =========================

    const orderRes =
      await axios.post(

        `${API_BASE}/api/payments/create-order`,

        {
  amount: 3999,

  type:
    "competitivePremium",
},

        {
          headers: {
            Authorization:
              `Bearer ${user.token}`,
          },
        }
      );



    const { order } =
      orderRes.data;



    // =========================
    // Razorpay Config
    // =========================

    const razorpay =
      new window.Razorpay({

        key:
          process.env.REACT_APP_RAZORPAY_KEY,

        amount:
          order.amount,

        currency:
          order.currency,

        name:
          "UPSC Journey",

        description:
          "Premium Competitive Ecosystem",

        image:
          "/logo192.png",

        order_id:
          order.id,



        // =========================
        // Prefill
        // =========================

        prefill: {

          email:
            user?.email || "",

          name:
            user?.name || "",
        },



        // =========================
        // Notes
        // =========================

        notes: {

          feature:
            "Competitive Ecosystem Premium",
        },



        // =========================
        // Success Handler
        // =========================

        handler:
          async (response) => {

            try {

              // =========================
              // Verify Payment
              // =========================

              const verifyRes =
                await axios.post(

                  `${API_BASE}/api/payments/verify-payment`,

                  {
  razorpay_order_id:
    response.razorpay_order_id,

  razorpay_payment_id:
    response.razorpay_payment_id,

  razorpay_signature:
    response.razorpay_signature,

  type:
    "competitivePremium",
},

                  {
                    headers: {
                      Authorization:
                        `Bearer ${user.token}`,
                    },
                  }
                );



              // =========================
// Updated User
// =========================

const updatedUser = {

  ...verifyRes.data?.user,

  token: user.token,
};

// =========================
// Save Updated User
// =========================

if (!updatedUser) {

  toast.error(
    "Failed to refresh premium access"
  );

  return;
}

localStorage.setItem(
  "user",
  JSON.stringify(updatedUser)
);

setUser(updatedUser);

setCurrentUser(updatedUser);



// =========================
// Notify Entire App
// =========================

window.dispatchEvent(

  new Event(
    "userUpdated"
  )
);



// =========================
// Success Toast
// =========================

toast.success(

  "🎉 Premium unlocked successfully!"
);
// =========================
// Open Username Modal
// =========================

if (
  !hasCompetitiveDisplayName(updatedUser)
) {

  setShowDisplayNameModal(
    true
  );
}

            } catch (err) {

              console.error(err);

              toast.error(
                "Payment verification failed"
              );
            }
          },



        // =========================
        // Theme
        // =========================

        theme: {
          color: "#f59e0b",
        },



        // =========================
        // Modal Behaviour
        // =========================

        modal: {

          ondismiss: () => {

            toast(
              "Payment cancelled"
            );
          },
        },
      });



    // =========================
    // Open Razorpay
    // =========================

    razorpay.open();

  } catch (err) {

    console.error(err);

    toast.error(
      "Failed to start payment"
    );
  }
};

  // ✅ Razorpay Renewal
  const handleRenewNow = async () => {
    try {
      if (!window.Razorpay) {
        toast.error("Payment UI failed to load. Refresh the page.");
        return;
      }
      if (!user?.token) {
        toast.error("Please log in again.");
        return;
      }

      setRenewLoading(true);

      const orderRes = await axios.post(
        `${API_BASE}/api/payments/create-order`,
        { amount: 3999, renewal: true },
        { headers: { Authorization: `Bearer ${user.token}` } }
      );

      const { order } = orderRes.data;

      const razorpay = new window.Razorpay({
        key: process.env.REACT_APP_RAZORPAY_KEY,
        amount: order.amount,
        currency: order.currency,
        name: "UPSC Journey",
        description: "1-Year Subscription Renewal",
        order_id: order.id,
        prefill: { email: user.email },
        handler: async (response) => {
          try {
            const verifyRes = await axios.post(
              `${API_BASE}/api/payments/verify-payment`,
              {
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                renewal: true,
              },
              { headers: { Authorization: `Bearer ${user.token}` } }
            );

            const updatedUser = verifyRes.data?.user;
            if (updatedUser) {
              localStorage.setItem("user", JSON.stringify(updatedUser));
              setUser(updatedUser);
              window.dispatchEvent(new Event("userUpdated"));
              toast.success("✅ Subscription renewed successfully!");
            } else {
              toast.error("Failed to update subscription data.");
            }

            localStorage.removeItem("dashboardRenewBannerHidden");
            setBannerHidden(false);
          } catch (err) {
            console.error("Payment verification failed:", err);
            toast.error("Payment verification failed.");
          } finally {
            setRenewLoading(false);
          }
        },
        modal: { ondismiss: () => setRenewLoading(false) },
        theme: { color: "#2563eb" },
      });

      razorpay.open();
    } catch (err) {
      console.error("Renewal error:", err);
      toast.error("Failed to start renewal.");
      setRenewLoading(false);
    }
  };

  // =========================
// NEW Badge System
// =========================

const latestUpdates = {
  
  notes:
    localStorage.getItem(
      "notes-latest"
    ),

  mcqs:
    localStorage.getItem(
      "mcqs-latest"
    ),

  mains:
    localStorage.getItem(
      "mains-latest"
    ),

  "test-series":
    localStorage.getItem(
      "test-series-latest"
    ),

  "editorial-analysis":
    localStorage.getItem(
      "editorial-analysis-latest"
    ),

  "monthly-magazines":
    localStorage.getItem(
      "monthly-magazines-latest"
    ),
};

const hasNewContent = (path) => {

  const lastSeen =
    localStorage.getItem(
      `${path}-seen`
    );

  const latest =
    latestUpdates[path];

  if (!latest) return false;

  if (!lastSeen) return true;

  return (
    new Date(latest) >
    new Date(lastSeen)
  );
};

const markSectionSeen = (path) => {

  localStorage.setItem(
    `${path}-seen`,
    new Date().toISOString()
  );

  setRefreshBadges((prev) => !prev);
};

// =========================
// Live Activity Ticker
// =========================

  // ✅ Dashboard Cards
  const dashboardLinks = [
  {
    name: "Study Plans",
    path: "study-plans",
    icon: BookOpen,
    description: "Daily roadmap and revision flow",
    accent: "text-blue-600 dark:text-blue-300",
    surface: "bg-blue-50 dark:bg-blue-500/10",
  },

  {
    name: "Notes",
    path: "notes",
    icon: FileText,
    description: "Topic notes and quick revision",
    accent: "text-emerald-600 dark:text-emerald-300",
    surface: "bg-emerald-50 dark:bg-emerald-500/10",
  },

  {
    name: "MCQs",
    path: "mcqs",
    icon: HelpCircle,
    description: "Practice questions by date",
    accent: "text-violet-600 dark:text-violet-300",
    surface: "bg-violet-50 dark:bg-violet-500/10",
  },

  {
    name: "Mains",
    path: "mains",
    icon: PenLine,
    description: "Answer writing and feedback",
    accent: "text-rose-600 dark:text-rose-300",
    surface: "bg-rose-50 dark:bg-rose-500/10",
  },

  {
    name: "Test Series",
    path: "test-series",
    icon: BarChart2,
    description: "Mocks, scores, and analysis",
    accent: "text-amber-600 dark:text-amber-300",
    surface: "bg-amber-50 dark:bg-amber-500/10",
  },

  {
    name: "Hindu Editorial",
    path: "editorial-analysis",
    icon: FileText,
    description: "Editorial analysis for mains",
    accent: "text-red-600 dark:text-red-300",
    surface: "bg-red-50 dark:bg-red-500/10",
  },

  {
    name: "Monthly Magazine",
    path: "monthly-magazines",
    icon: Newspaper,
    description: "Monthly current affairs issues",
    accent: "text-cyan-600 dark:text-cyan-300",
    surface: "bg-cyan-50 dark:bg-cyan-500/10",
  },
];

// =========================
// Preparation Health Score
// =========================

const preparationScore = Math.min(
  100,
  Math.round(
    (
      (analytics?.notesRead || 0) * 2 +
      (analytics?.editorialsRead || 0) * 2 +
      (analytics?.mcqsSolved || 0) * 0.5 +
      (analytics?.testsAttempted || 0) * 10 +
      (analytics?.mainsAnswersSubmitted || 0) * 5 +
      (analytics?.streakDays || 0) * 2
    )
  )
);

const preparationStatus =
  preparationScore >= 80
    ? "🔥 Excellent"
    : preparationScore >= 50
    ? "⚡ Good"
    : "📈 Needs Improvement";

  const username = user?.username || user?.name || "User";

  // =========================
// Active Cycles
// =========================

const activePrelims =
  examCycles.find(
    (cycle) =>
      cycle?.examType === "prelims"
  );

const activeMains =
  examCycles.find(
    (cycle) =>
      cycle?.examType === "mains"
  );

// =========================
// Countdown Helper
// =========================

const getCountdownDays = (

cycle,

currentDate

) => {

if (

!cycle?.examDate ||

cycle?.isTentative

){

return null;

}

// Normalize today
const today =
new Date(
currentDate
);

today.setHours(
0,
0,
0,
0
);

// Normalize exam date
const examDate =
new Date(
cycle?.examDate
);

examDate.setHours(
0,
0,
0,
0
);

// Difference
const diff =

Math.floor(

(

examDate -

today

)

/

(

1000*
60*
60*
24

)

);

// Hide expired countdown

if (

diff < 0

){

return "ENDED";

}

return diff;

};
  
  return (
  <div className="relative min-h-screen p-6 overflow-hidden bg-gradient-to-br from-gray-50 to-white dark:from-gray-900 dark:to-gray-800 text-gray-900 dark:text-gray-100 transition-colors">
    <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-blue-500/10 blur-[150px] rounded-full animate-pulse" />

<div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-purple-500/10 blur-[150px] rounded-full animate-pulse" />
      
      {/* 🌙 Dark Mode Toggle */}
      <div className="flex justify-end mb-6">
        <button
          onClick={() => setDarkMode(!darkMode)}
          aria-label="Toggle theme"
          className="p-3 rounded-full border border-gray-300 dark:border-gray-700 shadow-md bg-white dark:bg-gray-800 hover:scale-110 transition-transform"
        >
          {darkMode ? (
            <Sun className="w-6 h-6 text-yellow-400 animate-spin-slow" />
          ) : (
            <Moon className="w-6 h-6 text-indigo-600 hover:animate-bounce" />
          )}
        </button>
      </div>

      {/* ✅ Renewal Countdown Banner */}
      {isActive && daysLeft <= 15 && !bannerHidden && (
        <div className="mb-6 p-4 bg-blue-100 border border-blue-300 rounded-xl text-blue-800 flex flex-col sm:flex-row justify-between items-start sm:items-center shadow-md">
          <div>
            ⏳ Your subscription expires in <strong>{daysLeft} days</strong>. Renew now to continue uninterrupted access!
          </div>
          <div className="flex gap-3 mt-3 sm:mt-0">
            <button
              onClick={handleRenewNow}
              disabled={renewLoading}
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md transition disabled:opacity-60"
            >
              {renewLoading ? "Processing…" : "🔄 Renew Now"}
            </button>
            <button
              onClick={handleHideBanner}
              className="text-sm text-gray-600 hover:text-gray-900 underline"
            >
              Hide
            </button>
          </div>
        </div>
      )}

      {/* ✅ Show Banner Again */}
      {bannerHidden && isActive && daysLeft <= 15 && (
        <div className="mb-6 p-3 text-center bg-gray-100 dark:bg-gray-800 rounded-md shadow-sm">
          🔔 You’ve hidden the renewal reminder.{" "}
          <button
            onClick={handleShowBanner}
            className="text-blue-600 font-medium underline hover:text-blue-800"
          >
            Show it again
          </button>
        </div>
      )}

      <section className="relative mb-10 overflow-hidden rounded-[2rem]">

  <div className="absolute inset-0 bg-gradient-to-br from-blue-600 via-indigo-600 to-purple-700" />

  <div className="absolute -top-20 -left-20 w-96 h-96 bg-cyan-400/20 rounded-full blur-3xl" />
  <div className="absolute bottom-0 right-0 w-96 h-96 bg-pink-500/20 rounded-full blur-3xl" />

  <div className="relative z-10 p-8 md:p-12">

    <div className="flex flex-col lg:flex-row justify-between gap-8">

      <div>

        <div className="text-blue-100 text-sm uppercase tracking-[0.3em] mb-4">
          UPSC MISSION CONTROL
        </div>

        <h1 className="text-4xl md:text-6xl font-black text-white">
          Welcome Back,
          <br />
          {username} 🚀
        </h1>

        <p className="mt-5 text-blue-100 text-lg max-w-2xl">
          {dailyQuote}
        </p>
      </div>

      <div className="grid grid-cols-2 gap-4">

        <div className="rounded-3xl bg-white/10 backdrop-blur-xl p-5">
          <div className="text-blue-100 text-xs">LEVEL</div>
          <div className="text-4xl font-black text-white">
            {analytics?.level || 1}
          </div>
        </div>

        <div className="rounded-3xl bg-white/10 backdrop-blur-xl p-5">
          <div className="text-blue-100 text-xs">XP</div>
          <div className="text-4xl font-black text-white">
            {analytics?.xpPoints || 0}
          </div>
        </div>

        <div className="rounded-3xl bg-white/10 backdrop-blur-xl p-5">
          <div className="text-blue-100 text-xs">STREAK</div>
          <div className="text-4xl font-black text-white">
            {analytics?.streakDays || 0}
          </div>
        </div>

        <div className="rounded-3xl bg-white/10 backdrop-blur-xl p-5">
          <div className="text-blue-100 text-xs">MCQs</div>
          <div className="text-4xl font-black text-white">
            {analytics?.mcqsSolved || 0}
          </div>
        </div>

      </div>

    </div>

  </div>
</section>

      {/* ========================= */}
{/* Live Activity Ticker */}
{/* ========================= */}

<div className="relative mb-8 overflow-hidden rounded-2xl border border-gray-200 dark:border-white/10 bg-white dark:bg-gray-800/40 backdrop-blur-xl shadow-2xl">

  {/* Glow Effect */}
  <div className="absolute inset-0 bg-gradient-to-r from-blue-500/10 via-cyan-500/10 to-purple-500/10" />

  <div className="relative flex items-center overflow-hidden py-4">

    {/* Left Label */}
    <div className="z-10 flex items-center gap-2 px-6 text-sm font-bold text-gray-900 dark:text-white whitespace-nowrap">

      <span className="flex h-3 w-3">

        <span className="absolute inline-flex h-3 w-3 rounded-full bg-red-400 opacity-75 animate-ping"></span>

        <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500"></span>
      </span>

      LIVE UPDATES
    </div>

    {/* Marquee */}
<div

className={`

flex

overflow-hidden

whitespace-nowrap

flex-1

transition-all

duration-700

${

activitiesLoaded

?

"opacity-100"

:

"opacity-0"

}

`}

>

  <div className="animate-marquee flex items-center gap-10 font-medium">

    {Array(2)
      .fill(activities)
      .flat()
      .map((activity, index) => (

        <div
          key={index}
          className="flex items-center gap-6"
        >

          <span className="text-gray-800 dark:text-white hover:text-cyan-500 dark:hover:text-cyan-300 transition-colors duration-300 whitespace-nowrap text-sm md:text-base">
            {activity}
          </span>

          <span className="text-cyan-500 text-xl opacity-70">
            •
          </span>

        </div>
      ))}

  </div>
</div>
  </div>
</div>

{/* ========================= */}
{/* UPSC Countdown Hero */}
{/* ========================= */}

<section className="relative overflow-hidden mb-10 rounded-3xl border border-white/10 bg-gradient-to-br from-indigo-600 via-blue-600 to-cyan-500 shadow-2xl">

  {/* Animated Glow */}
  <div className="absolute inset-0 opacity-30">

    <div className="absolute top-0 left-0 w-72 h-72 bg-white rounded-full blur-3xl animate-pulse"></div>

    <div className="absolute bottom-0 right-0 w-72 h-72 bg-cyan-300 rounded-full blur-3xl animate-pulse"></div>
  </div>


  <div className="relative z-10 p-8 md:p-10 flex flex-col xl:flex-row items-center justify-between gap-12">

    {/* ========================= */}
    {/* Left Content */}
    {/* ========================= */}

    <div className="max-w-2xl">

      <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/20 backdrop-blur-lg text-white text-sm font-semibold mb-5 shadow-lg">

        🚀 UPSC Journey Countdown
      </div>


      <h2 className="text-4xl md:text-5xl font-extrabold text-white mb-5 leading-tight">

        Stay Focused.
        <br />
        Stay Consistent.
      </h2>


      <p className="text-blue-100 text-lg leading-relaxed">

        Your UPSC success is built every single day through consistency,
        discipline, and smart preparation. Track your exam cycle and stay
        ahead of the competition.
      </p>


      {/* Small Stats */}
      <div className="mt-8 flex flex-wrap gap-4">

        <div className="px-5 py-3 rounded-2xl bg-white/10 backdrop-blur-xl border border-white/10 text-white">

          📚 Daily Learning
        </div>

        <div className="px-5 py-3 rounded-2xl bg-white/10 backdrop-blur-xl border border-white/10 text-white">

          🧠 Smart Preparation
        </div>

        <div className="px-5 py-3 rounded-2xl bg-white/10 backdrop-blur-xl border border-white/10 text-white">

          🎯 Goal Focused
        </div>
      </div>
    </div>



    {/* ========================= */}
    {/* Countdown Cards */}
    {/* ========================= */}

    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

      {[

activePrelims,

activeMains

]

.filter(
Boolean
)

.filter(

(cycle)=>{

if (!cycle)
return false;

const days =

getCountdownDays(

cycle,

liveDate

);

return (

cycle?.isTentative ||

days !== "ENDED"

);

}

)

.map(

(cycle,index)=>{

if (!cycle)
return null;


          const days =
  getCountdownDays(
    cycle,
    liveDate
  );

          return (

            <div
              key={
cycle?._id ||
cycle?.examType
}
              className="relative w-64 h-64 rounded-3xl border border-white/20 bg-white/10 backdrop-blur-xl flex flex-col items-center justify-center shadow-2xl overflow-hidden hover:scale-105 transition-transform duration-500"
            >

              {/* Glow */}
              <div className="absolute inset-0 bg-gradient-to-br from-white/10 to-cyan-300/10" />


              {/* Floating Blur */}
              <div className="absolute -top-10 -right-10 w-32 h-32 bg-cyan-300/20 rounded-full blur-3xl"></div>


              <div className="relative z-10 text-center px-5">

                {/* Exam Type */}
                <div className="text-sm uppercase tracking-[0.25em] text-blue-100 mb-3 font-semibold">

                  UPSC {cycle?.examType}
                </div>


                {/* Year */}
                <div className="text-3xl font-extrabold text-white mb-5">

                  {cycle.year}
                </div>



                {/* Official Countdown */}
                {days !== null ? (

                  <>
                    <div className="text-6xl font-extrabold text-white drop-shadow-lg">

                      {days}
                    </div>

                    <div className="mt-3 text-blue-100 font-semibold tracking-widest uppercase text-sm">

                      Days Left
                    </div>

                    <div className="mt-4 text-xs text-cyan-100">

                      Official Exam Cycle
                    </div>
                  </>

                ) : (

                  <>
                    <div className="text-2xl font-bold text-white leading-snug">

                      {cycle.expectedMonth}
                    </div>

                    <div className="mt-4 text-blue-100 uppercase tracking-widest text-sm font-semibold">

                      Tentative Cycle
                    </div>

                    <div className="mt-3 text-xs text-cyan-100">

                      Official Notification Awaited
                    </div>
                  </>
                )}
              </div>
            </div>
          );
        })}
    </div>
  </div>
</section>

      {/* Expired Notice */}
      {isExpired && hasSubscription && (
        <div className="mb-10 p-4 bg-yellow-100 border border-yellow-300 rounded-xl text-yellow-800 text-center shadow-md">
          ⚠️ Your premium subscription expired on{" "}
          <strong>{new Date(user.subscriptionExpiresAt).toLocaleDateString()}</strong>. You still have lifetime access to{" "}
          <strong>Study Plans</strong>, but other sections are locked until renewal.
        </div>
      )}     

{/* ========================= */}
{/* Preparation Health */}
{/* ========================= */}

<section className="mb-10">

  <div className="relative overflow-hidden rounded-[2rem] p-8 bg-gradient-to-r from-emerald-500 via-teal-500 to-cyan-600 text-white shadow-2xl">

    {/* Glow */}
    <div className="absolute top-0 right-0 w-72 h-72 bg-white/10 rounded-full blur-3xl" />

    <div className="relative z-10">

      <div className="text-sm uppercase tracking-[0.3em] opacity-80">
        Preparation Health
      </div>

      <div className="mt-4 text-6xl font-black">
        {preparationScore}%
      </div>

      <div className="mt-3 text-xl font-semibold">
        {preparationStatus}
      </div>

      <div className="mt-6 w-full h-4 rounded-full bg-white/20 overflow-hidden">

        <div
          className="h-full bg-white rounded-full transition-all duration-1000"
          style={{
            width: `${preparationScore}%`,
          }}
        />

      </div>

      <div className="mt-4 text-cyan-100 text-sm">

        Based on notes, editorials, MCQs, tests, mains writing and consistency.

      </div>

    </div>

  </div>

</section>

      
      {/* ========================= */}
{/* Premium Analytics Dashboard */}
{/* ========================= */}

<section className="mb-16 mt-16">

  {/* Header */}
  <div className="flex items-center justify-between mb-6">

    <div>

      <h2 className="text-3xl font-extrabold bg-gradient-to-r from-cyan-500 via-blue-500 to-purple-500 bg-clip-text text-transparent">

        📊 Your Preparation Analytics
      </h2>

      <p className="text-gray-600 dark:text-gray-400 mt-2">

        Track your preparation journey in real time.
      </p>
    </div>



    {/* Level Badge */}
    {!analyticsLoading && analytics && (

      <div className="px-6 py-3 rounded-2xl bg-gradient-to-r from-yellow-400 via-orange-500 to-pink-500 text-white shadow-2xl border border-white/20">

        <div className="text-xs uppercase tracking-widest opacity-80">

          Current Level
        </div>

        <div className="text-3xl font-extrabold">

          Lv. {analytics.level}
        </div>
      </div>
    )}
  </div>



  {/* Loading */}
  {analyticsLoading ? (

    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-6">

      {[...Array(8)].map((_, i) => (

        <div
          key={i}
          className="h-40 rounded-3xl bg-gray-200 dark:bg-gray-800 animate-pulse"
        />
      ))}
    </div>

  ) : (

    <>
      {/* Stats Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-6">

        {/* XP */}
        <div className="relative overflow-hidden rounded-3xl p-6 bg-gradient-to-br from-cyan-500 to-blue-600 text-white shadow-2xl">

          <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full blur-3xl" />

          <div className="relative z-10">

            <div className="text-sm uppercase tracking-widest opacity-80">

              XP Points
            </div>

            <div className="text-5xl font-extrabold mt-3">

              {analytics?.xpPoints || 0}
            </div>

            <div className="mt-4 text-cyan-100 text-sm">

              Total learning experience earned
            </div>
          </div>
        </div>



        {/* Streak */}
        <div className="relative overflow-hidden rounded-3xl p-6 bg-gradient-to-br from-orange-500 to-red-600 text-white shadow-2xl">

          <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full blur-3xl" />

          <div className="relative z-10">

            <div className="text-sm uppercase tracking-widest opacity-80">

              Study Streak
            </div>

            <div className="text-5xl font-extrabold mt-3">

              {analytics?.streakDays || 0}
            </div>

            <div className="mt-4 text-orange-100 text-sm">

              Consecutive active days
            </div>
          </div>
        </div>

        

        {/* MCQs */}
        <div className="relative overflow-hidden rounded-3xl p-6 bg-gradient-to-br from-purple-500 to-pink-600 text-white shadow-2xl">

          <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full blur-3xl" />

          <div className="relative z-10">

            <div className="text-sm uppercase tracking-widest opacity-80">

              MCQs Solved
            </div>

            <div className="text-5xl font-extrabold mt-3">

              {analytics?.mcqsSolved || 0}
            </div>

            <div className="mt-4 text-pink-100 text-sm">

              Practice consistency matters
            </div>
          </div>
        </div>



        {/* Tests */}
        <div className="relative overflow-hidden rounded-3xl p-6 bg-gradient-to-br from-green-500 to-emerald-600 text-white shadow-2xl">

          <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full blur-3xl" />

          <div className="relative z-10">

            <div className="text-sm uppercase tracking-widest opacity-80">

              Tests Attempted
            </div>

            <div className="text-5xl font-extrabold mt-3">

              {analytics?.testsAttempted || 0}
            </div>

            <div className="mt-4 text-green-100 text-sm">

              Competitive preparation progress
            </div>
          </div>
        </div>



        {/* Editorials */}
        <div className="relative overflow-hidden rounded-3xl p-6 bg-gradient-to-br from-indigo-500 to-blue-700 text-white shadow-2xl">

          <div className="relative z-10">

            <div className="text-sm uppercase tracking-widest opacity-80">

              Editorials Read
            </div>

            <div className="text-5xl font-extrabold mt-3">

              {analytics?.editorialsRead || 0}
            </div>
          </div>
        </div>

{/* Monthly Magazines */}
<div className="relative overflow-hidden rounded-3xl p-6 bg-gradient-to-br from-cyan-500 to-sky-700 text-white shadow-2xl">

  <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full blur-3xl" />

  <div className="relative z-10">

    <div className="text-sm uppercase tracking-widest opacity-80">

      Monthly Magazines
    </div>

    <div className="text-5xl font-extrabold mt-3">

      {analytics?.monthlyMagazinesRead || 0}
    </div>

    <div className="mt-4 text-cyan-100 text-sm">

      Current affairs magazines completed
    </div>

  </div>
</div>

        {/* Notes */}
        <div className="relative overflow-hidden rounded-3xl p-6 bg-gradient-to-br from-yellow-500 to-amber-600 text-white shadow-2xl">

          <div className="relative z-10">

            <div className="text-sm uppercase tracking-widest opacity-80">

              Notes Read
            </div>

            <div className="text-5xl font-extrabold mt-3">

              {analytics?.notesRead || 0}
            </div>
          </div>
        </div>



        {/* Mains Answers */}
        <div className="relative overflow-hidden rounded-3xl p-6 bg-gradient-to-br from-pink-500 to-rose-600 text-white shadow-2xl">

          <div className="relative z-10">

            <div className="text-sm uppercase tracking-widest opacity-80">

              Mains Answers
            </div>

            <div className="text-5xl font-extrabold mt-3">

              {analytics?.mainsAnswersSubmitted || 0}
            </div>
          </div>
        </div>

        {/* Level Progress */}
        <div className="relative overflow-hidden rounded-3xl p-6 bg-gradient-to-br from-gray-900 to-black text-white shadow-2xl border border-white/10">

          <div className="relative z-10">

            <div className="text-sm uppercase tracking-widest opacity-80 mb-4">

              Level Progress
            </div>

            <div className="w-full h-4 rounded-full bg-white/10 overflow-hidden">

              <div
                className="h-full bg-gradient-to-r from-cyan-400 via-blue-500 to-purple-500 rounded-full transition-all duration-700"
                style={{
  width: `${
    analytics?.nextLevelXP
      ? (
          (analytics?.currentLevelXP ?? 0)
          /
          (analytics?.nextLevelXP ?? 1)
        ) * 100
      : 0
  }%`,
}}
              />
            </div>

            <div className="mt-4 text-sm text-gray-300">

              {analytics?.currentLevelXP ?? 0}
/
{analytics?.nextLevelXP ?? 0} XP to next level
            </div>
          </div>
        </div>
      </div>
    </>
  )}
</section>

      {/* ========================= */}
{/* Premium Competitive Ecosystem */}
{/* ========================= */}

{!currentUser?.hasPaid && (

  <section className="mb-16">

    <div className="relative overflow-hidden rounded-[2rem] border border-yellow-400/20 bg-gradient-to-br from-yellow-50 via-orange-50 to-pink-100 dark:from-yellow-500/10 dark:via-orange-500/10 dark:to-pink-500/10 shadow-[0_20px_80px_rgba(0,0,0,0.15)]">

      {/* Glow Effects */}
      <div className="absolute inset-0 opacity-20 pointer-events-none">

        <div className="absolute -top-20 -left-10 w-72 h-72 bg-yellow-400 rounded-full blur-3xl"></div>

        <div className="absolute bottom-0 right-0 w-72 h-72 bg-pink-500 rounded-full blur-3xl"></div>

      </div>



      {/* Decorative Grid */}
      <div className="absolute inset-0 opacity-[0.04] bg-[linear-gradient(to_right,#000_1px,transparent_1px),linear-gradient(to_bottom,#000_1px,transparent_1px)] bg-[size:40px_40px] dark:opacity-[0.06]"></div>



      <div className="relative z-10 p-8 md:p-12 flex flex-col xl:flex-row items-start xl:items-center justify-between gap-12">

        {/* Left Content */}
        <div className="max-w-3xl">

          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-yellow-400/20 text-yellow-700 dark:text-yellow-300 font-semibold text-sm backdrop-blur-xl border border-yellow-400/20 mb-6">

            🔒 Premium Competitive Ecosystem
          </div>



          {/* Heading */}
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 dark:text-white leading-tight mb-6">

            Unlock AIR Rankings,
            <br />

            Leaderboards & Competitive Analytics
          </h2>



          {/* Description */}
          <p className="text-lg text-gray-700 dark:text-gray-300 leading-relaxed max-w-2xl">

            Compete anonymously with serious UPSC aspirants through advanced preparation analytics, XP systems, streak competitions, rankings and AIR-style performance tracking.
          </p>



          {/* Features Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-10">

            {[
              {
                icon: "🏆",
                title: "National Leaderboards",
              },

              {
                icon: "⚡",
                title: "XP Ranking System",
              },

              {
                icon: "🔥",
                title: "Streak Battles",
              },

              {
                icon: "📊",
                title: "Comparative Analytics",
              },

              {
                icon: "🎯",
                title: "AIR Simulation",
              },

              {
                icon: "📈",
                title: "Performance Comparison",
              },

              {
                icon: "🧠",
                title: "Smart Insights",
              },

              {
                icon: "🚀",
                title: "Competitive Ecosystem",
              },
            ].map((item) => (

              <div
                key={item.title}
                className="group relative overflow-hidden rounded-2xl bg-white/80 dark:bg-white/5 border border-white/20 dark:border-white/10 backdrop-blur-xl px-5 py-5 transition-all duration-300 hover:scale-[1.02] hover:shadow-2xl"
              >

                {/* Hover Glow */}
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition duration-500 bg-gradient-to-r from-yellow-400/10 via-orange-400/10 to-pink-400/10"></div>

                <div className="relative z-10 flex items-center gap-4">

                  <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-yellow-400 to-orange-500 flex items-center justify-center text-xl shadow-lg">

                    {item.icon}
                  </div>

                  <div>

                    <div className="font-bold text-gray-900 dark:text-white">

                      {item.title}
                    </div>

                    <div className="text-sm text-gray-500 dark:text-gray-400 mt-1">

                      Premium feature
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>



        {/* Right CTA */}
        <div className="w-full xl:w-auto flex flex-col items-center xl:items-end">

          {/* Pricing Card */}
          <div className="relative overflow-hidden rounded-[2rem] border border-white/20 bg-white/80 dark:bg-black/20 backdrop-blur-2xl p-8 shadow-2xl w-full max-w-sm">

            {/* Glow */}
            <div className="absolute inset-0 opacity-20">

              <div className="absolute top-0 right-0 w-40 h-40 bg-yellow-400 rounded-full blur-3xl"></div>

            </div>



            <div className="relative z-10 text-center">

              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-green-500/10 text-green-600 dark:text-green-300 border border-green-500/20 text-sm font-semibold mb-5">

                ⭐ Most Popular
              </div>



              <div className="text-6xl font-black text-gray-900 dark:text-white tracking-tight">

                ₹3,999
              </div>



              <div className="mt-3 text-gray-600 dark:text-gray-400 text-lg">

                yearly premium access
              </div>



              {/* Benefits */}
              <div className="space-y-3 mt-8 text-left">

                {[
                  "All premium study materials",
                  "Competitive analytics ecosystem",
                  "AIR-style rankings",
                  "Unlimited premium access",
                  "Leaderboard participation",
                ].map((benefit) => (

                  <div
                    key={benefit}
                    className="flex items-center gap-3 text-gray-700 dark:text-gray-300"
                  >

                    <div className="w-5 h-5 rounded-full bg-gradient-to-r from-green-400 to-emerald-500 flex items-center justify-center text-white text-xs">

                      ✓
                    </div>

                    <span className="text-sm">

                      {benefit}
                    </span>
                  </div>
                ))}
              </div>



              {/* CTA */}
              <button

                onClick={handleCompetitiveUpgrade}

                className="mt-8 w-full px-10 py-5 rounded-2xl bg-gradient-to-r from-yellow-400 via-orange-500 to-pink-500 hover:from-yellow-300 hover:via-orange-400 hover:to-pink-400 text-white text-lg font-bold shadow-[0_15px_40px_rgba(255,165,0,0.35)] transition-all duration-300 hover:scale-[1.03]"
              >
                🚀 Upgrade to Premium
              </button>



              <p className="mt-5 text-sm text-gray-500 dark:text-gray-400 leading-relaxed">

                Includes full access to all premium study resources and competitive ecosystem features.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
)}

      {/* ========================= */}
{/* Competitive Profile Card */}
{/* ========================= */}

{showCompetitiveCard && (

  <section className="mb-10">

    <div className="relative overflow-hidden rounded-3xl border border-cyan-500/20 bg-gradient-to-br from-cyan-50 via-blue-50 to-purple-100 dark:from-cyan-500/10 dark:via-blue-500/10 dark:to-purple-500/10 backdrop-blur-xl shadow-2xl"
>

      {/* Glow */}
      <div className="absolute inset-0 opacity-20">

        <div className="absolute top-0 left-0 w-72 h-72 bg-cyan-500 rounded-full blur-3xl"></div>

        <div className="absolute bottom-0 right-0 w-72 h-72 bg-purple-500 rounded-full blur-3xl"></div>
      </div>



      <div className="relative z-10 p-6 md:p-8 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">

        {/* Left */}
        <div>

          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-cyan-500/20 text-gray-900 dark:text-white mb-4">

            🏆 Competitive Ecosystem
          </div>

          <h2 className="text-3xl font-extrabold text-gray-900 dark:text-white mb-3">

            Unlock Rankings & Leaderboards
          </h2>

          <p className="text-gray-700 dark:text-gray-300 max-w-2xl leading-relaxed">

            Create your anonymous competitive profile to access AIR-style rankings, streak competitions, XP systems and advanced preparation analytics.
          </p>



          {/* Features */}
          <div className="flex flex-wrap gap-3 mt-5">

            <div className="px-4 py-2 rounded-xl bg-white/70 dark:bg-white/5 border border-white/10 text-sm text-gray-700 dark:text-gray-300">

              ⚡ XP Rankings
            </div>

            <div className="px-4 py-2 rounded-xl bg-white/70 dark:bg-white/5 border border-white/10 text-sm text-gray-700 dark:text-gray-300">

              🔥 Streak Battles
            </div>

            <div className="px-4 py-2 rounded-xl bg-white/70 dark:bg-white/5 border border-white/10 text-sm text-gray-700 dark:text-gray-300">

              📊 Competitive Analytics
            </div>

            <div className="px-4 py-2 rounded-xl bg-white/70 dark:bg-white/5 border border-white/10 text-sm text-gray-700 dark:text-gray-300">

              🏆 AIR Simulation
            </div>

          </div>
        </div>

        {/* CTA */}
        <div className="flex flex-col gap-3 w-full lg:w-auto">

          <button

  onClick={async () => {

  // =========================
  // FREE USER
  // =========================

  if (!currentUser?.hasPaid) {

    await handleCompetitiveUpgrade();

    return;
  }



  // =========================
  // PREMIUM USER WITHOUT NAME
  // =========================

  if (!hasCompetitiveDisplayName(currentUser)) {

    setShowDisplayNameModal(
      true
    );

    return;
  }



  // =========================
  // FULLY ACTIVATED
  // =========================

  toast.success(
    "Competitive ecosystem already active"
  );
}}

  className="px-8 py-4 rounded-2xl bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-400 hover:to-blue-500 text-white font-bold shadow-2xl transition-all duration-300"
>
  {currentUser?.hasPaid
    ? "🚀 Activate Competitive Profile"
    : "🔒 Premium Required"}
</button>
        </div>
      </div>
    </div>
  </section>
)}

{/* ========================= */}
{/* Competitive Leaderboard */}
{/* ========================= */}

{currentUser?.hasPaid &&
hasCompetitiveDisplayName(currentUser) && (

<section className="mb-16">

  <div className="relative overflow-hidden rounded-[2rem] border border-yellow-400/20 bg-gradient-to-br from-yellow-50 via-orange-50 to-pink-100 dark:from-yellow-500/10 dark:via-orange-500/10 dark:to-pink-500/10 shadow-2xl p-8">

    {/* Glow */}
    <div className="absolute inset-0 opacity-20">

      <div className="absolute top-0 left-0 w-72 h-72 bg-yellow-400 rounded-full blur-3xl"></div>

      <div className="absolute bottom-0 right-0 w-72 h-72 bg-pink-500 rounded-full blur-3xl"></div>
    </div>

    <div className="relative z-10">

      {/* Header */}
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6 mb-10">

        <div>

          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-yellow-400/20 text-yellow-700 dark:text-yellow-300 font-semibold text-sm mb-4">

            🏆 Competitive Ecosystem
          </div>

          <h2 className="text-4xl font-extrabold text-gray-900 dark:text-white">

            National Leaderboards
          </h2>

          <p className="mt-3 text-gray-700 dark:text-gray-300 max-w-2xl">

            Track your competitive preparation rank among serious UPSC aspirants anonymously.
          </p>
        </div>



        {/* User Rank */}
        <div className="rounded-3xl bg-white/70 dark:bg-black/20 backdrop-blur-xl border border-white/20 p-6 shadow-2xl min-w-[250px]">

          <div className="text-sm uppercase tracking-widest text-gray-500 dark:text-gray-400">

            Your Rank
          </div>

          <div className="text-6xl font-black text-gray-900 dark:text-white mt-2">

            #{currentRank || "--"}
          </div>

          <div className="mt-4 space-y-2">

  <div className="text-sm text-gray-600 dark:text-gray-400">

    Ahead of{" "}

    <span className="font-bold text-gray-900 dark:text-white">

      {percentile}%
    </span>{" "}

    aspirants
  </div>

  <div className="text-sm text-gray-600 dark:text-gray-400">

    Rank{" "}

    <span className="font-bold text-yellow-600 dark:text-yellow-400">

      #{currentRank || "--"}
    </span>{" "}

    among{" "}

    <span className="font-bold text-gray-900 dark:text-white">

      {totalUsers}
    </span>{" "}

    competitive users
  </div>
</div>
          <div className="mt-5 pt-5 border-t border-white/10">

  <div className="text-xs uppercase tracking-widest text-gray-500 dark:text-gray-400 mb-2">

    Projected AIR
  </div>

  <div className="text-3xl font-black text-yellow-500">

    AIR {

      leaderboard.find(
        (u) =>
          u.rank === currentRank
      )?.projectedAIR || "--"
    }
  </div>

  <div className="mt-3 inline-flex items-center px-3 py-1 rounded-full bg-gradient-to-r from-yellow-400/20 to-orange-400/20 text-yellow-700 dark:text-yellow-300 text-sm font-bold">

    {

      leaderboard.find(
        (u) =>
          u.rank === currentRank
      )?.tier || "Beginner"
    }
  </div>
</div>
        </div>
      </div>



      {/* ========================= */}
{/* PREMIUM LEADERBOARD */}
{/* ========================= */}

{leaderboardLoading ? (

  <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">

    {[...Array(6)].map((_, i) => (

      <div
        key={i}
        className="h-36 rounded-[2rem] bg-white/40 dark:bg-white/5 animate-pulse"
      />
    ))}
  </div>

) : (

  <>

    {/* ========================= */}
    {/* TOP 3 PODIUM */}
    {/* ========================= */}

    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">

      {leaderboard.slice(0, 3).map((user, index) => {

        const podiumStyles = [

          {
            medal: "🥇",
            border:
              "border-yellow-300/40",
            glow:
              "from-yellow-300 via-yellow-400 to-orange-500",
            translate:
              "md:-translate-y-6",
          },

          {
            medal: "🥈",
            border:
              "border-gray-300/40",
            glow:
              "from-gray-300 via-gray-400 to-gray-500",
            translate:
              "md:translate-y-4",
          },

          {
            medal: "🥉",
            border:
              "border-orange-300/40",
            glow:
              "from-orange-300 via-orange-400 to-amber-600",
            translate:
              "md:translate-y-8",
          },
        ];

        const style =
          podiumStyles[index];

        return (

          <div
            key={`${user.displayName}-${user.rank}`}
            className={`relative overflow-hidden rounded-[2.5rem] border ${style.border} bg-white/80 dark:bg-black/20 backdrop-blur-2xl shadow-[0_20px_80px_rgba(0,0,0,0.18)] p-8 text-center transition-all duration-500 hover:scale-105 ${style.translate}`}
          >

            {/* Glow */}
            <div
              className={`absolute inset-0 opacity-20 bg-gradient-to-br ${style.glow}`}
            />

            {/* Floating Blur */}
            <div className="absolute -top-10 left-1/2 -translate-x-1/2 w-40 h-40 bg-yellow-300/20 rounded-full blur-3xl"></div>

            <div className="relative z-10">

              {/* Medal */}
              <div className="text-6xl mb-4">

                {style.medal}
              </div>

              {/* Rank */}
              <div className="text-sm uppercase tracking-[0.3em] text-gray-500 dark:text-gray-400">

                National Rank
              </div>

              <div className="text-7xl font-black mt-2 text-gray-900 dark:text-white">

                #{user.rank}
              </div>

              {/* Name */}
              <div className="mt-5 text-2xl font-black text-gray-900 dark:text-white break-words">

                {user.displayName}
              </div>

              {/* Tier */}
              <div className="mt-4 inline-flex px-4 py-2 rounded-full bg-white/60 dark:bg-white/10 text-sm font-bold text-yellow-700 dark:text-yellow-300 border border-white/20">

                {user.tier}
              </div>

              {/* Stats */}
              <div className="grid grid-cols-2 gap-4 mt-8">

                <div className="rounded-2xl bg-white/50 dark:bg-white/5 p-4">

                  <div className="text-xs uppercase tracking-widest text-gray-500">

                    XP
                  </div>

                  <div className="text-3xl font-black mt-2 text-gray-900 dark:text-white">

                    {user.xp}
                  </div>
                </div>

                <div className="rounded-2xl bg-white/50 dark:bg-white/5 p-4">

                  <div className="text-xs uppercase tracking-widest text-gray-500">

                    AIR
                  </div>

                  <div className="text-3xl font-black mt-2 text-yellow-500">

                    {user.projectedAIR || "--"}
                  </div>
                </div>
              </div>

              {/* Score */}
              <div className="mt-8">

                <div className="text-xs uppercase tracking-[0.3em] text-gray-500">

                  Competitive Score
                </div>

                <div className="text-5xl font-black mt-3 bg-gradient-to-r from-yellow-500 via-orange-500 to-pink-500 bg-clip-text text-transparent">

                  {user.score}
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>

    {/* ========================= */}
    {/* REMAINING USERS */}
    {/* ========================= */}

    <div className="space-y-5">

      {leaderboard.slice(3).map((user) => (

        <div
          key={`${user.displayName}-${user.rank}`}
          className={`group relative overflow-hidden rounded-[2rem] border backdrop-blur-2xl p-6 transition-all duration-300 hover:scale-[1.02]

          ${
            user.rank === currentRank

              ? "bg-gradient-to-r from-yellow-400/20 via-orange-400/10 to-pink-400/20 border-yellow-300/30 shadow-[0_10px_50px_rgba(255,180,0,0.25)]"

              : "bg-white/70 dark:bg-white/5 border-white/20 shadow-xl"
          }`}
        >

          {/* Hover Glow */}
          <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition duration-500 bg-gradient-to-r from-yellow-400/10 via-orange-400/10 to-pink-400/10"></div>

          <div className="relative z-10 flex flex-col lg:flex-row lg:items-center justify-between gap-6">

            {/* LEFT */}
            <div className="flex items-center gap-6">

              {/* Rank */}
              <div
                className={`w-20 h-20 rounded-3xl flex items-center justify-center text-3xl font-black shadow-2xl

                ${
                  user.rank === currentRank

                    ? "bg-gradient-to-br from-yellow-400 to-orange-500 text-white"

                    : "bg-white dark:bg-white/10 text-gray-900 dark:text-white"
                }`}
              >

                #{user.rank}
              </div>

              {/* User Info */}
              <div>

                <div className="flex items-center flex-wrap gap-3">

                  <div className="text-2xl font-black text-gray-900 dark:text-white">

                    {user.displayName}
                  </div>

                  {user.rank === currentRank && (

                    <span className="px-3 py-1 rounded-full bg-yellow-400 text-black text-xs font-black">

                      YOU
                    </span>
                  )}
                </div>

                {/* Small Stats */}
                <div className="flex flex-wrap gap-3 mt-4">

                  <div className="px-4 py-2 rounded-xl bg-white/60 dark:bg-white/5 text-sm font-semibold text-gray-700 dark:text-gray-300">

                    ⚡ {user.xp} XP
                  </div>

                  <div className="px-4 py-2 rounded-xl bg-white/60 dark:bg-white/5 text-sm font-semibold text-gray-700 dark:text-gray-300">

                    🔥 {user.streak} Day Streak
                  </div>

                  <div className="px-4 py-2 rounded-xl bg-white/60 dark:bg-white/5 text-sm font-semibold text-gray-700 dark:text-gray-300">

                    🎯 AIR {user.projectedAIR || "--"}
                  </div>
                </div>
              </div>
            </div>

            {/* RIGHT */}
            <div className="text-right">

              <div className="text-xs uppercase tracking-[0.3em] text-gray-500 dark:text-gray-400">

                Competitive Score
              </div>

              <div className="mt-3 text-5xl font-black text-gray-900 dark:text-white">

                {user.score}
              </div>

              <div className="mt-4 inline-flex px-4 py-2 rounded-full bg-gradient-to-r from-yellow-400/20 to-orange-400/20 text-yellow-700 dark:text-yellow-300 text-sm font-black border border-yellow-300/20">

                {user.tier}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>

    </>
)}

    </div>
  </div>
</section>
)}

      {/* Explore Section */}
      <section className="mb-12">
        <div className="mb-6">
          <div className="flex items-center gap-2 text-sm font-semibold uppercase tracking-wider text-blue-600 dark:text-blue-300">
            <Sparkles className="h-4 w-4" />
            Continue learning
          </div>
          <h2 className="mt-2 text-2xl font-bold text-gray-900 dark:text-white">
            Explore Sections
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {dashboardLinks.map(({ name, path, icon: Icon, description, accent, surface }) => {
            const isStudyPlans = path === "study-plans";
            const isDisabled = isExpired && hasSubscription && !isStudyPlans;
            const hasNew = hasNewContent(path);

            return (
              <div
                key={name}
                className={`group relative min-h-[144px] rounded-2xl border border-gray-200 bg-white p-5 shadow-sm transition duration-200 hover:-translate-y-1 hover:shadow-md dark:border-white/10 dark:bg-gray-900/70 ${
                  isDisabled ? "opacity-70" : ""
                }`}
              >
                {isDisabled ? (
                  <div className="flex h-full flex-col justify-between gap-5">
                    <div className="flex items-start justify-between gap-4">
                      <div className={`rounded-2xl ${surface} p-3`}>
                        <Icon className={`h-6 w-6 ${accent}`} />
                      </div>
                      <Lock className="h-5 w-5 text-gray-400" />
                    </div>
                    <div>
                      <h3 className="text-lg font-bold text-gray-900 dark:text-white">
                        {name}
                      </h3>
                      <p className="mt-1 text-sm leading-6 text-gray-500 dark:text-gray-400">
                        Renew subscription to unlock
                      </p>
                    </div>
                  </div>
                ) : (
                  <Link
                    to={path}
                    onClick={() => markSectionSeen(path)}
                    className="flex h-full flex-col justify-between gap-5"
                  >
                    <div className="flex items-start justify-between gap-4">
                      <div className={`rounded-2xl ${surface} p-3 transition-colors group-hover:bg-gray-100 dark:group-hover:bg-white/10`}>
                        <Icon className={`h-6 w-6 ${accent}`} />
                      </div>
                      {hasNew && (
                        <span className="rounded-full bg-red-50 px-2.5 py-1 text-xs font-bold text-red-600 ring-1 ring-red-100 dark:bg-red-500/10 dark:text-red-300 dark:ring-red-500/20">
                          NEW
                        </span>
                      )}
                    </div>
                    <div>
                      <h3 className="text-lg font-bold text-gray-900 dark:text-white">
                        {name}
                      </h3>
                      <p className="mt-1 text-sm leading-6 text-gray-500 dark:text-gray-400">
                        {description}
                      </p>
                    </div>
                  </Link>
                )}
              </div>
            );
          })}
        </div>
      </section>
      {/* Announcements Section */}
      <section className="mb-12">
        <div className="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm dark:border-white/10 dark:bg-gray-900/70 md:p-6">
          <div className="mb-6 flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
            <div className="flex items-center gap-3">
              <div className="rounded-2xl bg-indigo-50 p-3 dark:bg-indigo-500/10">
                <Megaphone className="h-6 w-6 text-indigo-600 dark:text-indigo-300" />
              </div>
              <div>
                <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
                  Latest Announcements
                </h2>
                <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
                  Official updates and important notices
                </p>
              </div>
            </div>
            <span className="w-fit rounded-full bg-gray-100 px-3 py-1.5 text-sm font-semibold text-gray-700 dark:bg-white/10 dark:text-gray-200">
              {announcements.length} {announcements.length === 1 ? "Announcement" : "Announcements"}
            </span>
          </div>

          {announcements.length === 0 ? (
            <div className="rounded-2xl border border-dashed border-gray-200 py-14 text-center dark:border-white/10">
              <Megaphone className="mx-auto mb-4 h-10 w-10 text-gray-400 dark:text-gray-600" />
              <p className="text-sm font-medium text-gray-600 dark:text-gray-400">
                No announcements available. Stay tuned.
              </p>
            </div>
          ) : (
            <div
              className={`grid gap-4 ${
                announcements.length === 1 ? "grid-cols-1" : "sm:grid-cols-2 lg:grid-cols-3"
              }`}
            >
              {announcements.map((ann) => (
                <article
                  key={ann._id}
                  className={`relative rounded-2xl border p-5 transition duration-200 hover:-translate-y-1 hover:shadow-md ${
                    ann.isImportant
                      ? "border-red-200 bg-red-50 dark:border-red-500/30 dark:bg-red-500/10"
                      : "border-gray-200 bg-gray-50 dark:border-white/10 dark:bg-white/5"
                  }`}
                >
                  <div className="mb-4 flex flex-wrap items-center gap-2">
                    <span className="rounded-full bg-indigo-100 px-3 py-1 text-xs font-bold text-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-300">
                      {ann.category}
                    </span>
                    {ann.isImportant && (
                      <span className="inline-flex items-center gap-1 rounded-full bg-red-600 px-3 py-1 text-xs font-bold text-white">
                        <Flame className="h-3.5 w-3.5" />
                        Priority
                      </span>
                    )}
                  </div>

                  <h3 className="text-lg font-bold leading-snug text-gray-900 dark:text-white">
                    {ann.title}
                  </h3>

                  <div className="mt-3 flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400">
                    <CalendarDays className="h-4 w-4" />
                    <span>
                      {new Date(ann.visibility.startDate).toLocaleDateString()} - {new Date(ann.visibility.endDate).toLocaleDateString()}
                    </span>
                  </div>

                  <p className="mt-4 whitespace-pre-line text-sm leading-6 text-gray-700 dark:text-gray-300">
                    {ann.body}
                  </p>
                </article>
              ))}
            </div>
          )}
        </div>
      </section>
{/* Display Name Setup Modal */}
{/* ========================= */}

{showDisplayNameModal && (

  <DisplayNameModal

  onClose={() => {

    setShowDisplayNameModal(
      false
    );

    setDismissedCompetitiveModal(
      true
    );
  }}

  onSuccess={(
    updatedUser
  ) => {

    // =========================
    // Sync React State
    // =========================

    if (updatedUser) {

      const finalUser = {

        ...updatedUser,

        hasPaid: true,
      };



      setCurrentUser(
        finalUser
      );

      setUser(
        finalUser
      );



      localStorage.setItem(

        "user",

        JSON.stringify(
          finalUser
        )
      );
    }



    // =========================
    // Hide UI
    // =========================

    setShowDisplayNameModal(
      false
    );

    setShowCompetitiveCard(
      false
    );



    // =========================
    // Refresh Leaderboard
    // =========================

    fetchLeaderboard();

    fetchAnalytics();
  }}
/>
)}
{/* ========================= */}
{/* Live XP Popup */}
{/* ========================= */}

{xpPopup && (
  <div className="fixed inset-x-4 bottom-5 z-[9999] sm:inset-x-auto sm:right-6 sm:top-6 sm:bottom-auto">
    <div className="relative overflow-hidden rounded-2xl border border-amber-200 bg-white px-5 py-4 text-gray-900 shadow-2xl dark:border-amber-500/30 dark:bg-gray-900 dark:text-white sm:min-w-[320px]">
      <div className="flex items-start gap-4">
        <div className="rounded-2xl bg-amber-50 p-3 dark:bg-amber-500/10">
          <Zap className="h-6 w-6 text-amber-600 dark:text-amber-300" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-xs font-bold uppercase tracking-wider text-gray-500 dark:text-gray-400">
            Competitive Progress
          </div>
          <div className="mt-1 text-3xl font-black text-gray-900 dark:text-white">
            +{xpPopup.xp} XP
          </div>
          <div className="mt-2 flex items-start gap-2 text-sm font-semibold text-gray-700 dark:text-gray-200">
            <Flame className="mt-0.5 h-4 w-4 shrink-0 text-orange-500" />
            <span>{xpPopup.message}</span>
          </div>
          {xpPopup.rank && (
            <div className="mt-3 flex items-center gap-2 text-sm text-gray-600 dark:text-gray-300">
              <Trophy className="h-4 w-4 text-yellow-500" />
              Rank #{xpPopup.rank}
            </div>
          )}
          {xpPopup.air && (
            <div className="mt-1 flex items-center gap-2 text-sm text-gray-600 dark:text-gray-300">
              <Target className="h-4 w-4 text-blue-500" />
              AIR {xpPopup.air}
            </div>
          )}
        </div>
      </div>
    </div>
  </div>
)}

{/* ========================= */}
{/* Rank Improvement Popup */}
{/* ========================= */}

{rankChange && (
  <div className="fixed inset-x-4 bottom-5 z-[9999] sm:inset-x-auto sm:right-6 sm:top-32 sm:bottom-auto">
    <div className="relative overflow-hidden rounded-2xl border border-emerald-200 bg-white px-5 py-4 text-gray-900 shadow-2xl dark:border-emerald-500/30 dark:bg-gray-900 dark:text-white sm:min-w-[340px]">
      <div className="flex items-start gap-4">
        <div className="rounded-2xl bg-emerald-50 p-3 dark:bg-emerald-500/10">
          <Trophy className="h-6 w-6 text-emerald-600 dark:text-emerald-300" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-xs font-bold uppercase tracking-wider text-gray-500 dark:text-gray-400">
            National Ranking Improved
          </div>
          <div className="mt-2 flex items-center gap-3 text-2xl font-black text-gray-900 dark:text-white">
            <span>#{rankChange.oldRank}</span>
            <span className="text-base text-emerald-500">to</span>
            <span>#{rankChange.newRank}</span>
          </div>
          <div className="mt-2 text-sm font-semibold text-gray-700 dark:text-gray-200">
            You're climbing the leaderboard.
          </div>
        </div>
      </div>
    </div>
  </div>
)}
    </div>
  );
};

export default DashboardHome;
